<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CCardTitle>CloudRouter ☁️</CCardTitle>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="filteredNav" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'
import navAdmin from './_nav_admin'

// 分组展开的路径前缀映射（CSidebarNavDropdown 只按 route 属性做 includes 匹配，
// /interface、/ip、/link-ip 等独立前缀的页面不会触发 Router 分组展开，这里显式映射）
const GROUP_PATH_PREFIXES = {
  'Router': ['/router', '/interface', '/ip', '/link-ip', '/region', '/router-id'],
  'Routing': ['/routing'],
  'Tunnels': ['/tunnel'],
  'CMDB': ['/cmdb'],
  'DDNS': ['/ddns'],
  'Setting': ['/user']
}

export default {
  name: 'TheSidebar',
  nav,
  navAdmin,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    },
    filteredNav () {
      const isAdmin = this.$cookies.get('is_admin') === '1'
      // 统一深拷贝，避免污染模块级 nav 对象
      let filtered = JSON.parse(JSON.stringify(nav))
      if (isAdmin) {
        // admin 显示完整菜单
      } else {
        // 普通用户只显示 Index、Port Forward、Setting
        filtered[0]._children = filtered[0]._children.filter(item => {
          if (!item.name) return true // 保留 title/divider
          return ['Index', 'Port Forward', 'Setting'].includes(item.name)
        })
        // 去掉 Router title（普通用户没有 Router 菜单）
        filtered[0]._children = filtered[0]._children.filter((item, idx, arr) => {
          if (item._name === 'CSidebarNavTitle' && item._children && item._children[0] === 'Router') {
            return false
          }
          return true
        })
      }
      // 当前路径所属分组自动展开（注入 show，CSidebarNavDropdown watch 后 open）
      const currentPath = this.$route.path
      filtered[0]._children.forEach(item => {
        if (item._name !== 'CSidebarNavDropdown') return
        const prefixes = GROUP_PATH_PREFIXES[item.name]
        if (!prefixes) return
        if (prefixes.some(p => currentPath === p || currentPath.startsWith(p + '/') || currentPath.startsWith(p))) {
          item.show = true
        }
      })
      return filtered
    }
  }
}
</script>
